'use strict';

class OrderTranslationService {
    translate(mdDataTableOrder) {
        let translatedOrder = "";
        if (mdDataTableOrder.substring(0,1) === "-") {
            translatedOrder = mdDataTableOrder.substring(1) + " DESC";
        } else {
            translatedOrder = mdDataTableOrder;
        }

        return translatedOrder;
    };
}

export default OrderTranslationService;
